export default {
  sources: [],
  source: null,
  pagination: {}
}
